module.exports = __webpack_public_path__ + "img/home_img_10.42b93e0a.png";